/**
 * @fileoverview gRPC-Web generated client stub for order_transaction_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v6.32.1
// source: orderTransaction.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as orderTransaction_pb from './orderTransaction_pb'; // proto import: "orderTransaction.proto"


export class OrderTransactionEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/order_transaction_endpoint.OrderTransactionEndpoint/Update',
    grpcWeb.MethodType.UNARY,
    orderTransaction_pb.UpdateOrderTransactionRequest,
    orderTransaction_pb.UpdateOrderTransactionResponse,
    (request: orderTransaction_pb.UpdateOrderTransactionRequest) => {
      return request.serializeBinary();
    },
    orderTransaction_pb.UpdateOrderTransactionResponse.deserializeBinary
  );

  update(
    request: orderTransaction_pb.UpdateOrderTransactionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<orderTransaction_pb.UpdateOrderTransactionResponse>;

  update(
    request: orderTransaction_pb.UpdateOrderTransactionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.UpdateOrderTransactionResponse) => void): grpcWeb.ClientReadableStream<orderTransaction_pb.UpdateOrderTransactionResponse>;

  update(
    request: orderTransaction_pb.UpdateOrderTransactionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.UpdateOrderTransactionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_transaction_endpoint.OrderTransactionEndpoint/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_transaction_endpoint.OrderTransactionEndpoint/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorUpdateState = new grpcWeb.MethodDescriptor(
    '/order_transaction_endpoint.OrderTransactionEndpoint/UpdateState',
    grpcWeb.MethodType.UNARY,
    orderTransaction_pb.UpdateOrderTransactionStateRequest,
    orderTransaction_pb.UpdateOrderTransactionStateResponse,
    (request: orderTransaction_pb.UpdateOrderTransactionStateRequest) => {
      return request.serializeBinary();
    },
    orderTransaction_pb.UpdateOrderTransactionStateResponse.deserializeBinary
  );

  updateState(
    request: orderTransaction_pb.UpdateOrderTransactionStateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<orderTransaction_pb.UpdateOrderTransactionStateResponse>;

  updateState(
    request: orderTransaction_pb.UpdateOrderTransactionStateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.UpdateOrderTransactionStateResponse) => void): grpcWeb.ClientReadableStream<orderTransaction_pb.UpdateOrderTransactionStateResponse>;

  updateState(
    request: orderTransaction_pb.UpdateOrderTransactionStateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.UpdateOrderTransactionStateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_transaction_endpoint.OrderTransactionEndpoint/UpdateState',
        request,
        metadata || {},
        this.methodDescriptorUpdateState,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_transaction_endpoint.OrderTransactionEndpoint/UpdateState',
    request,
    metadata || {},
    this.methodDescriptorUpdateState);
  }

  methodDescriptorGetOrderTransactions = new grpcWeb.MethodDescriptor(
    '/order_transaction_endpoint.OrderTransactionEndpoint/GetOrderTransactions',
    grpcWeb.MethodType.UNARY,
    orderTransaction_pb.GetOrderTransactionsRequest,
    orderTransaction_pb.GetOrderTransactionsResponse,
    (request: orderTransaction_pb.GetOrderTransactionsRequest) => {
      return request.serializeBinary();
    },
    orderTransaction_pb.GetOrderTransactionsResponse.deserializeBinary
  );

  getOrderTransactions(
    request: orderTransaction_pb.GetOrderTransactionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<orderTransaction_pb.GetOrderTransactionsResponse>;

  getOrderTransactions(
    request: orderTransaction_pb.GetOrderTransactionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.GetOrderTransactionsResponse) => void): grpcWeb.ClientReadableStream<orderTransaction_pb.GetOrderTransactionsResponse>;

  getOrderTransactions(
    request: orderTransaction_pb.GetOrderTransactionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.GetOrderTransactionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_transaction_endpoint.OrderTransactionEndpoint/GetOrderTransactions',
        request,
        metadata || {},
        this.methodDescriptorGetOrderTransactions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_transaction_endpoint.OrderTransactionEndpoint/GetOrderTransactions',
    request,
    metadata || {},
    this.methodDescriptorGetOrderTransactions);
  }

  methodDescriptorGetOrderTransaction = new grpcWeb.MethodDescriptor(
    '/order_transaction_endpoint.OrderTransactionEndpoint/GetOrderTransaction',
    grpcWeb.MethodType.UNARY,
    orderTransaction_pb.GetOrderTransactionRequest,
    orderTransaction_pb.GetOrderTransactionResponse,
    (request: orderTransaction_pb.GetOrderTransactionRequest) => {
      return request.serializeBinary();
    },
    orderTransaction_pb.GetOrderTransactionResponse.deserializeBinary
  );

  getOrderTransaction(
    request: orderTransaction_pb.GetOrderTransactionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<orderTransaction_pb.GetOrderTransactionResponse>;

  getOrderTransaction(
    request: orderTransaction_pb.GetOrderTransactionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.GetOrderTransactionResponse) => void): grpcWeb.ClientReadableStream<orderTransaction_pb.GetOrderTransactionResponse>;

  getOrderTransaction(
    request: orderTransaction_pb.GetOrderTransactionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: orderTransaction_pb.GetOrderTransactionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_transaction_endpoint.OrderTransactionEndpoint/GetOrderTransaction',
        request,
        metadata || {},
        this.methodDescriptorGetOrderTransaction,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_transaction_endpoint.OrderTransactionEndpoint/GetOrderTransaction',
    request,
    metadata || {},
    this.methodDescriptorGetOrderTransaction);
  }

}

